// IMPORT REACT
import React from "react";
import Axios from "axios";

// IMPORT CONTAINERS
import Layout from '../../Layout';

// IMPORT COMPONENTS
import YALogo from '../../../components/Logo';
import YAIcon from '../../../components/Icon';
import YAContainer from '../../../components/Grid/Container';
import YASection from '../../../components/Grid/Section';
import YARow from '../../../components/Grid/Row';
import YAColumn from '../../../components/Grid/Column';
import YAText from '../../../components/Text';
import YAButton from '../../../components/Form/Button';
import YAModal from '../../../components/Modal';
import YAEmbed from '../../../components/Embed';

// IMPORT STYLES
import { 
  Sc_PlayVideoBtn, 
  Sc_AppPreviewImage, 
  Sc_IconList, 
  Sc_IconContainer, 
  Sc_DividedList 
} from '../../styles';

class Home extends React.Component {

  constructor(props) {
    super();
    this.state = {
      modalOpen : false
    }
  }

  render(){
    return (
      <Content {...this.props} open ={false}/>
    );
  }
};

const Content = ({ lang, page, bloginfo, open }) => {

	return (
    <Layout lang={lang} page={page} bloginfo={bloginfo}
    	header={
    		<Header page={page} bloginfo={bloginfo} />
    	}
    	body={
    		<div>
    		  <SectionMiddle page={page} />
          <SectionBottom page={page} />
        </div>
    	}
      
    />
  );
}

class Header extends React.Component{

  state = {
    modalOpen: false
  }
  
  render(){
    const bloginfo = this.props.bloginfo;
    const page = this.props.page;

    return (
      <div>
        <YALogo brand="ymca-text" height="15px" fill="white" margin={["0", "5px"]} />
        <YALogo brand="weemarkable" height="50px" fill="white" margin={["0", "spacer"]} />
        
        <YARow center>
          <YAColumn size="col-md-8 col-lg-6">
            <YAText tag="h1" bootstrap="h2">
              {bloginfo ? bloginfo.description : null}
            </YAText>
          </YAColumn>
          <YAColumn size="col-md-10 col-lg-8">
            <YAEmbed src={page ? page['meta']['page_section_0_youtube_link']+'?rel=0' : null} />
            <br/><br/>
            <YAButton href={page ? page['meta']['page_header_download_apple_link'] : '/'} color="light" width="150px" icon="apple">
              {page ? page['meta']['page_header_download_apple'] : null}
            </YAButton>
            <YAButton href={page ? page['meta']['page_header_download_android_link'] : '/'} color="light" width="150px" icon="google-play">
              {page ? page['meta']['page_header_download_android'] : null}
            </YAButton>
          </YAColumn>
        </YARow>
        <Sc_AppPreviewImage/>
      </div>
    )
  }
};

const SectionMiddle = ({ page }) => (
  <YASection>
    <YAContainer textAlign="center">
      <YARow center>
        <YAColumn size="col-lg-7">
          <YAText tag="h2">
            {page ? page['meta']['home_section_1_heading'] : null}
          </YAText>
          <YAText tag="h5" style={{whiteSpace: 'pre-wrap'}}>
            {page ? page['meta']['home_section_1_description'] : null}
          </YAText>
          <br/><br/><br/>
        </YAColumn>
      </YARow>
    </YAContainer>
    <YAContainer>
      <YARow>
        <YAColumn size="col-lg-6">
          <Sc_IconList>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="lock" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_1'] : null}
              </YAText>
            </li>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="grid" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_2'] : null}
              </YAText>
            </li>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="image" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_3'] : null}
              </YAText>
            </li>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="warning" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_4'] : null}
              </YAText>
            </li>
          </Sc_IconList>
        </YAColumn>
        <YAColumn size="col-lg-6">
          <Sc_IconList>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="user-plus" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_5'] : null}
              </YAText>
            </li>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="list" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_6'] : null}
              </YAText>
            </li>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="utensils" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_7'] : null}
              </YAText>
            </li>
            <li>
              <Sc_IconContainer>
                <YAIcon icon="comments" fill="primary" height="60px" />
              </Sc_IconContainer>
              <YAText tag="p">
                {page ? page['meta']['home_section_1_text_8'] : null}
              </YAText>
            </li>
          </Sc_IconList>
        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

const SectionBottom = ({ page }) => (
  <YASection background="teal" angle="top">
    <YAContainer>
      <YARow center>
        <YAColumn size="col-md-8 col-lg-6">
          <YAText tag="h2" divider="true" textAlign="center">
            {page ? page['meta']['home_section_2_heading'] : null}
          </YAText>
          <Sc_DividedList>
            <li>
              <YAText tag="p">
                {page ? page['meta']['home_section_2_text_1'] : null}
              </YAText>
            </li>
            <li>
              <YAText tag="p">
                {page ? page['meta']['home_section_2_text_2'] : null}
              </YAText>
            </li>
            <li>
              <YAText tag="p">
                {page ? page['meta']['home_section_2_text_3'] : null}
              </YAText>
            </li>
            <li>
              <YAText tag="p">
                {page ? page['meta']['home_section_2_text_4'] : null}
              </YAText>
            </li>
            <li>
              <YAText tag="p">
                {page ? page['meta']['home_section_2_text_5'] : null}
              </YAText>
            </li>
          </Sc_DividedList>
        </YAColumn>
       </YARow>
       <YARow>
        <YAColumn textAlign="center">
          <YAButton href={page ? page['meta']['page_header_download_apple_link'] : '/'} color="light" width="150px" icon="apple">
            {page ? page['meta']['page_header_download_apple'] : null}
          </YAButton>
          <YAButton href={page ? page['meta']['page_header_download_android_link'] : '/'} color="light" width="150px" icon="google-play">
            {page ? page['meta']['page_header_download_android'] : null}
          </YAButton>
        </YAColumn>
      </YARow>
    </YAContainer>
  </YASection>
);

export default Home;